<template>
  <div id="widget-builder-large">
    <p class="widget-instructions">
      {{ $t("widget_details.step_2") }}
    </p>
    <p>
      {{ $t("widget_details.builder_link1") }}
      <a @click="scrollMeTo('custom_attributes')">
        {{ $t("widget_details.builder_link2") }}
      </a>
      {{ $t("widget_details.builder_link3") }}
    </p>
    <br />
    <div class="columns">
      <div class="column is-12">
        <div class="card widget-options">
          <div class="columns ">
            <div class="column is-6">
              <!-- html code box -->
              <div class="card-content">
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.html_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.html_title") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <div class="is-block widget-code">
                  <div class="html-code" ref="text">
                    &lt;{{ widget.tag }}
                    <br />
                    <div v-if="selectedLanguage != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;lang="{{
                        selectedLanguage
                      }}"
                    </div>
                    <div v-if="selectedLanguage === null">
                      &nbsp;&nbsp;&nbsp;&nbsp;lang="{{ langChange }}"
                    </div>
                    <div v-if="myLabel != ''">
                      &nbsp;&nbsp;&nbsp;&nbsp;label="{{ labelChange }}"
                    </div>
                    <div v-if="selectedProvince != ''">
                      &nbsp;&nbsp;&nbsp;&nbsp;location="{{ locationChange }}"
                    </div>
                    <div v-if="styleOption != ''">
                      &nbsp;&nbsp;&nbsp;&nbsp;style-option="{{ styleChange }}"
                    </div>
                    &gt;&lt;/{{ widget.tag }}&gt;
                  </div>
                  <ButtonCopy class="is-small is-pulled-right"></ButtonCopy>
                </div>
              </div>
              <div class="card-content">
                <!-- live example box -->
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.example_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.example_title") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <div class="card-content live-example-bbf">
                  <div id="divBBF" :class="styleChange == '4' ? 'blue-bg' : ''" class="mt-2 mb-2 is-justify-content-center">
                    <open-services-bbf-widget id="bbfw" :lang="langChange" :label="labelChange" :location="locationChange" :style-option="styleChange"></open-services-bbf-widget>
                  </div>
                </div>
              </div>
            </div>
            <!-- widget options form box -->
            <div class="column is-6 triangle-left column-dark">
              <div class="card-content">
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    type="is-light"
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.options_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.component_options") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <!-- form start -->
                <form id="widget-form" class="widget-form">
                  <!-- language select -->
                  <div class="field is-horizontal">
                    <div class="field-label has-text-white">
                      <label class="label">{{ $t('form_options.label_lang') }}</label>
                    </div>
                    <div class="field-body">
                      <div class="field is-narrow">
                        <div class="control">
                          <span>
                            <input
                              id="languageEn"
                              type="radio"
                              name="myLang"
                              v-model="selectedLanguage"
                              value="en"
                              aria-checked="true"
                              aria-labelledby="languageEn"
                              @click="onClickRadiobox('languageEn')"
                             />
                            <label for="languageEn" class="radio ml-2">{{ $t('form_options.label_en') }}</label>
                          </span>
                          <span class="ml-5">
                            <input
                              id="languageFr"
                              type="radio"
                              name="myLang"
                              v-model="selectedLanguage"
                              value="fr"
                              aria-checked="false"
                              aria-labelledby="languageFr"
                              @click="onClickRadiobox('languageFr')"
                            />
                            <label for="languageFr" class="radio ml-2">{{ $t('form_options.label_fr') }}</label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- label input -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_options.label_label')"
                    label-for="field-label"
                  >
                    <b-input
                      id="mylabel"
                      v-model="myLabel"
                      :placeholder="$t('form_options.placeholder_label')"
                    ></b-input>
                  </b-field>
                  <!-- location input -->
                  <b-field
                    horizontal
                    :label="$t('form_options.label_location')"
                    label-for="location"
                    class="my-custom-class"
                  >
                    <b-select
                      id="location"
                      multiple
                      expanded
                      v-model="selectedProvince"
                      :placeholder="$t('form_options.placeholder_location')"
                    >
                      <option
                        v-for="option of $t('form_options.provinceOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- style option input -->
                  <b-field
                    horizontal
                    :label="$t('form_options.label_style')"
                    label-for="style"
                    class="my-custom-class"
                  >
                    <b-select
                      id="style"
                      expanded
                      v-model="styleOption"
                      :placeholder="$t('form_options.placeholder_style')"
                    >
                      <option
                        v-for="option of $t('form_options.styleOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <div class="mt-2 mb-2 has-text-white">
                    <p class="pt-2">{{ $t('form_options.note_style') }}</p>
                  </div>
                  <!-- reset button -->
                  <b-button
                    @click="resetForm()"
                    class="is-light is-pulled-right"
                  >
                    {{ $t("form_fields.reset") }}
                  </b-button>
                </form>
                <div class="card-content">
                  <a
                    id="custAttLink"
                    tabindex="0"
                    @keyup.enter="onEnter"
                    @click="scrollMeTo('custom_attributes')"
                    class="docs-link is-pulled-right"
                  >
                    {{ $t("widget_details.custom_attributes_docs") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonCopy from "@/components/ButtonCopy.vue";
export default {
  name: "WidgetBuilderBBF",
  props: {
    widget: { type: Object, required: true }
  },
  data() {
    return {
      selectedLanguage: "en",
      myLabel: "",
      selectedProvince: [],
      styleOption: 1 
    };
  },
  components: {
    ButtonCopy
  },
  computed: {
    langChange: function() {
      return this.selectedLanguage;
    },
    labelChange: function() {
      return this.myLabel;
    },
    locationChange: function() {
      var tempProv = this.selectedProvince.toString(); // convert array to string to show string in HTML code section
      return tempProv;
    },
    styleChange: function() {
      return this.styleOption;
    }
  },
  methods: {
    scrollMeTo: function(refName) {
      var element = this.$parent.$refs[refName]
      var top = element.offsetTop
      window.scrollTo(0, top)
    },
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    },
    resetForm: function() {
      this.selectedLanguage = "en",
      this.myLabel = "",
      this.selectedProvince = [],
      this.styleOption = 1 
    },
    onClickRadiobox: function (radioboxid) {
      if (radioboxid == "languageFr") {
        this.waitForElm("languageFr").then((elm) => {
          elm.setAttribute('aria-checked', 'true')
        })
        this.waitForElm("languageEn").then((elm) => {
          elm.setAttribute('aria-checked', 'false')
        })
      } else {
        this.waitForElm("languageEn").then((elm) => {
          elm.setAttribute('aria-checked', 'true')
        })
        this.waitForElm("languageFr").then((elm) => {
          elm.setAttribute('aria-checked', 'false')
        })
      }
    }, // end onClickRadiobox
    waitForElm: function (selector) {
      return new Promise(resolve => {
        if (document.getElementById(selector)) {
          return resolve(document.getElementById(selector));
        }
        const observer = new MutationObserver(() => {
          if (document.getElementById(selector)) {
            resolve(document.getElementById(selector));
            observer.disconnect();
          }
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    } // end waitForElm
  }
};
</script>
<style scoped>
  /* live widget css */
  .live-example-bbf {
    background: #fff;
    margin: 0 0px 0 0px;
    border-radius: 5px;
    padding: 10px 10px 20px 10px;
    border: 1px dashed #274f6e;
    text-align: center;
  }
  .blue-bg {
    background-color: #274f6e;
  }
  .field-label {
    flex-grow: 1.5;
  }
  .field-body {
    flex-grow: 3;
  }
  label:hover {
    color: white;
  }
</style>
